module.exports = __webpack_public_path__ + "static/media/green_marker.bcb3515e.svg";